import sanitizeHtml from "sanitize-html";

export function sanitize(html: string): string {
  return sanitizeHtml(html, {
    ...sanitizeHtml.defaults,
    allowedTags: [...sanitizeHtml.defaults.allowedTags, "carousel", "slide"],

    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      carousel: ["children"],
      slide: ["image", "title", "subtitle", "link", "price"],
      // Allow style attribute on all elements (only given the CSS restrictions)
      "*": ["style"],
    },

    allowedStyles: {
      "*": {
        // More secure: restrict font-weight to known valid values
        "font-weight": [
          /^bold$/,
          /^normal$/,
          /^bolder$/,
          /^lighter$/,
          /^[1-9]00$/, // 100, 200, 300, 400, 500, 600, 700, 800, 900
        ],

        // More secure: restrict color to safe formats
        color: [
          /^#([0-9a-f]{3}|[0-9a-f]{6})$/i, // Hex colors like #fff or #ff5926
          /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/i, // RGB colors
          /^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(0|1|0?\.\d+)\s*\)$/i, // RGBA colors
          /^(red|blue|green|black|white|gray|grey|yellow|orange|purple|pink|brown|cyan|magenta)$/i, // Named colors
        ],
        // Add other CSS properties as needed:
        // 'font-size': [/^\d+(?:px|em|rem|%)$/],
        // 'text-decoration': [/^(?:underline|none|line-through)$/],
        // 'text-align': [/^(?:left|right|center|justify)$/]
      },
    },
  });
}
